module.exports = __webpack_public_path__ + "img/gameover-screen.395f81b7.png";